import React from "react";

var CaretLeftIcon = function CaretLeftIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M13.532 4.585L6 12l7.532 7.415c.792.779 2.081.779 2.873 0s.792-2.049 0-2.829L11.746 12l4.659-4.587c.384-.378.595-.88.595-1.414s-.211-1.036-.595-1.414a2.056 2.056 0 0 0-2.873 0z"
  }));
};

CaretLeftIcon.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
CaretLeftIcon.defaultProps.solid = true;
export default CaretLeftIcon;